import classNames from 'classnames'
import React from 'react'
import { toggleFullscreen } from '../../../store/map/mapSlice'
import { selectIsMapFullScreen } from '../../../store/map/map.selectors'
import { withOnlyPE } from '../../Device'
import innerArrows from '../../genericComponents/assets/inner-arrows.svg'
import SVGIcon from '../../svg/SVGIcon'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './ToggleFullscreenPeButton.less'
import { useDispatch } from 'react-redux'

const ToggleFullscreenPeButton = () => {
  const dispatch = useDispatch()
  const onClick = useEventCallback(() => dispatch(toggleFullscreen()), [toggleFullscreen])

  return (
    <div className={classNames('icon', s.ToggleFullscreenButton)} onClick={onClick}>
      <SVGIcon url={innerArrows} />
    </div>
  )
}

export default withOnlyPE(withEverySelectorTruthy(selectIsMapFullScreen)(ToggleFullscreenPeButton))
